<template>
    <div class="wrapper">
        <div class="use">
            <div class="content">
                <span class="logo">
                    <img src="../assets/logo.png" alt="logo">
                </span>
                <div class="head">
                    <header></header>
                    <span class="title">LadyM蛋糕券兑换码</span>
                </div>
                <div class="body">
                    <div class="code">
                        <div class="qrcode" ref="qrCodeUrl"></div>
                    </div>
                    <div class="sec">请出示以上券码给门店工作人员</div>
                </div>
                <div class="foot">
                    <h1>注意:请妥善保管好您的二维码您在LadyM各大门店均可凭二维码进行蛋糕兑换,谢谢!</h1>
                    <div class="dec">
                        <p>时间：工作日9:00-17:00</p>
                        <p>客服电话：0571-85199986</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="use_loading" v-if="loading">
            <div class="loading">
                <img src="../assets/loading.png" alt="加载中">
            </div>
        </div>
    </div>
</template>
<script>
import QRCode from 'qrcodejs2'; //引入生成二维码插件
import JsBarcode from 'jsbarcode';
// var JsBarcode = require('jsbarcode');
export default {
    data(){
        return{
            loading:true,
            key:this.$route.query.key,
            amount:this.$route.query.amount,
            effectiveDate:this.$route.query.effectiveDate,
            expiredDate:this.$route.query.expiredDate,
            status:this.$route.query.status,
            ticket:{},
            used:false
        }
    },
    mounted(){
        // this.getTicket();
        this.creatQrCode(this.key);
    },
    methods:{
        creatQrCode(val) {
            
            let qrcode = new QRCode(this.$refs.qrCodeUrl, {
                text: val,
                width: 178,
                height: 178,
                colorDark: '#000000',
                colorLight: '#ffffff',
                correctLevel: QRCode.CorrectLevel.H
            });
            this.loading = false;
        },
        getTicket(){
            const obj = {
                ticketNo:this.key
            };
            this.$http.POST('productTicket/selectProductTicket',obj).then(res=>{
                this.loading = false;
                console.log(res);
                if(res.code===0){
                    if(res.data.status==2||res.data.status==3){
                        this.used = true;
                    }else{
                        this.used = false;
                        this.ticket = res.data;
                        this.creatQrCode(this.ticket.ticketNum);
                        JsBarcode("#barcode", this.ticket.ticketNum,{
                            displayValue: false,
                            width: 1.8,
                　　 　　    height: 60,
                        });
                    }
                    
                }else{

                }
            });
        }
    }
}
</script>
<style lang="scss" scoped>
.wrapper{
    height: 100%;
    position: relative;
    .use{
        height: 100%;
        background: #108EE9;
        padding: 30px 15px 15px 15px;
        box-sizing: border-box;
        .content{
            background: #fff;
            border-radius: 4px;
            background: url('../assets/code_bg.png') #fff center 20px no-repeat;
            background-size: 305px 338px;
            min-height: 338px;
            position: relative;
            .logo{
                position: absolute;
                display: inline-block;
                right: 0;
                top: 0;
                img{
                    width: 51px;
                    height: 51px;
                }
            }
            .head{
                position: relative;
                height: 30px;
                width: 100%;
                display: flex;
                justify-content: center;
                header{
                    width: 190px;
                    border-top: 30px solid #2C78DC;
                    border-right: 12px solid transparent;
                    border-left:12px solid transparent;
                    box-sizing: border-box;
                    height: 30px;
                }
                .title{
                    font-size: 15px;
                    position: absolute;
                    top: 0;
                    left: 0;
                    color: #fff;
                    width: 100%;
                    height: 30px;
                    line-height: 30px;
                    text-align: center;
                }
            }
            .body{
                border-bottom:1px dashed #CCCCCC;
                p{
                    font-size: 15px;
                    color: #999999;
                    text-align: center;
                    padding-top: 10px;
                }
                h1{
                    font-size: 20px;
                    color: #333333;
                    text-align: center;
                    padding-top: 15px;
                }
                .code{
                    padding-top: 70px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    .qrcode{
                        padding-top: 10px;
                    }
                }
                .sec{
                    font-size: 15px;
                    color: #999999;
                    padding: 30px 0 15px 0;
                    text-align: center;
                }
                .dec{
                    font-size: 15px;
                    background: #FEFCEC;
                    padding: 10px 0;
                    color: #F76A24;
                    text-align: center;
                }
                .btn{
                    display: flex;
                    justify-content: center;
                    padding: 15px 0 30px 0;
                    .button{
                        font-size: 15px;
                        width: 200px;
                        height: 40px;
                        line-height: 40px;
                        text-align: center;
                        color: #fff;
                        background: #1E87FC;
                        border-radius: 4px;
                    }
                }
            }
            .foot{
                padding: 1px 20px;
                h1{
                    font-size: 16px;
                    color: #F67737;
                    font-weight: bold;
                }
                .dec{
                    padding: 30px 0 80px 0;
                    p{
                        text-align: center;
                        font-size: 15px;
                        color: #333333;
                        line-height: 21px;
                    }
                }
            }
        }
    }
    
    .use_loading{
        position: absolute;
        height: 100%;
        width: 100%;
        z-index: 11;
        left: 0;
        top: 0;
        .loading{
            width: 100%;
            height: 100%;
            background: rgba(0,0,0,0.5);
            display: flex;
            justify-content: center;
            align-items: center;
            img{
                width:50px;
                height: 50px;
                animation:turn .8s linear infinite;      
                margin: 100px auto;
            }
            @keyframes turn{
                0%{-webkit-transform:rotate(0deg);}
                25%{-webkit-transform:rotate(90deg);}
                50%{-webkit-transform:rotate(180deg);}
                75%{-webkit-transform:rotate(270deg);}
                100%{-webkit-transform:rotate(360deg);}
            }
        }
    } 
}
</style>